/**
* DevExpress HTML/JS Reporting (viewer\mobile\internal\_mobilePreviewModel.js)
* Version:  23.1.6
* Build date: Oct 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { PreviewDisposableModel } from '../../internal/_previewModel';
export class MobilePreviewModel extends PreviewDisposableModel {
    constructor(options) {
        super(options);
        this.slideOptions = options.slideOptions;
        this.gallery = options.gallery;
        this.paginator = options.paginator;
        this.brickEventsDisabled = options.brickEventsDisabled;
        this.availableFormats = options.availableFormats;
        this._disposables.push(options.gallery);
        if (ko.isComputed(options.brickEventsDisabled))
            this._disposables.push(options.brickEventsDisabled);
        if (options.slideOptions && ko.isComputed(options.slideOptions.scrollAvailable))
            this._disposables.push(options.slideOptions.scrollAvailable);
        if (options.slideOptions && ko.isComputed(options.slideOptions.swipeEnabled))
            this._disposables.push(options.slideOptions.swipeEnabled);
        this._disposables.push(options.paginator);
        this._disposables.push(options.searchModel);
    }
}
